<template>
    <div class="row">
        <div class="col-12">
            <TitleComponent title="Seleccione los abonos:"></TitleComponent>
        </div>
        <template v-if="abonos">
            <div v-for="abono in abonos" :key="abono.id" class="col-md-6">
                <!-- Widget: user widget style 1 -->
                <div class="card card-widget widget-user shadow-lg">
                    <!-- Add the bg color to the header using any of the bg-* classes -->
                    <div class="widget-user-header text-white" :style="'background: url(' + abono.imagen_url + ') center center;'">
                    </div>
                    <div class="card-footer pt-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="my-4">
                                    <h5 class="description-header pb-3">{{ abono.descripcion }}</h5>
                                    <small><span class="description-text" v-html="abono.resumen"></span></small>
                                </div>
                                
                            </div>
                            
                            <div class="col-12" v-if="getAbonosMax(abono) > 0">
                                <div class="form-group m-0" v-if="!abono.place_id">
                                    <select class="form-control" v-model="abono.unidades">
                                        <option value="0">0</option>
                                        <template v-for="i in getAbonosMax(abono)">
                                            <option :key="i" :value="i">{{ i }}</option>                                     
                                        </template>                                            
                                    </select>
                                </div>
                                <div class="mt-3">
                                    <Button @click="continuar(abono)" class="btn-block">CONTINUAR</Button>
                                </div>
                            </div>
                            <div class="col-12" v-else>
                                <h2>Abonos agotados</h2>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </template>
        <template v-else>
            <div class="col-12" style="padding: 200px">
                <LoaderComponent></LoaderComponent>
            </div>
        </template>
        <div class="col-12" v-if="error_select_abonos">
            <p>Debes seleccionar al menos un abono para continuar</p>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';

    export default {
        props: [],
        data() {
            return {
                loading: true,
                search: null,
                zonas: null,
                datos_compradores: [],
                session_id: null,
                error_select_abonos: false,
                abonos: null
            }
        },
        created() {
            this.getTiposAbonos();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }    
        },
        methods: {
            goTo(paso, tipo_abono, recinto) {
                this.$emit('goTo', paso, tipo_abono, recinto);
            },
            getAbonosMax(abono) {
                if(abono.stock_calculado < 8) {
                    return abono.stock_calculado;
                } else {
                    return 8
                }
            },
            continuar(abono) {
                if(!abono.place_id ) {
                    if(abono.unidades > 0) {
                        this.continuarAbonoSinRecinto(abono);
                    } else {
                        this.$toast.error('Debes seleccionar al menos un abono para continuar.');
                    }
                    
                } else {
                    this.continuarAbonosConRecinto(abono);
                }      
            },
            continuarAbonosConRecinto(abono) {
                this.datos_compradores = abono;

                this.goTo(1, this.datos_compradores, abono.place);
            },
            continuarAbonoSinRecinto (abono) {
                for (var j = 0; j < abono.unidades; j++) {
                    this.datos_compradores.push({
                        area: Object.assign({}, abono),
                        tipo_abono: Object.assign({}, abono)
                    });
                }

                if(this.datos_compradores.length > 0) {
                    this.bloquearAbonos();
                }
            },
            bloquearAbonos (datos_compradores) {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    abonos: this.datos_compradores,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.abonos'), params).then(res => {
                    this.session_id = res.data.session_id;
                    this.loading = false;
                    this.goTo(3, this.datos_compradores, false);
                }).catch(error => {
                    this.$toast.error('Este asiento ya ha sido elegido por otro usuario.');
                    this.datos_compradores = [];
                    console.log(error);
                    this.loading = false;
                });
            },
            getTiposAbonos() {
                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.abonos = res.data;

                    for (var i in this.abonos) {
                        this.abonos[i].unidades = 0;
                    }
                });
            },
        },
        components: {
            TitleComponent
        }
    }
</script>

<style>

</style>
